import React from "react";
import { Link } from "react-router-dom";
import Header from "./Header";
import Footer from "./Footer";

function CareerDetails5() {
return (
<> <Header />


  <section className="container" style={{ paddingTop: "120px" }}>
    <div
      style={{
        display: "flex",
        alignItems: "center",
        gap: "20px",
        marginBottom: "40px",
      }}
    >
      <div
        style={{
          width: "300px",
          height: "1px",
          backgroundColor: "#dcdcdc",
        }}
      ></div>

      <p
        style={{
          margin: 0,
          fontSize: "16px",
          color: "#888",
        }}
      >
        <Link
          to="/"
          style={{
            color: "#111",
            textDecoration: "none",
          }}
        >
          Home
        </Link>

        {" / "}

        <Link
          to="/careers"
          style={{
            color: "#111",
            textDecoration: "none",
          }}
        >
          Careers
        </Link>

        {" / "} Senior Motion Graphic Designer
      </p>
    </div>

    <h1
      style={{
        textAlign: "center",
        fontSize: "64px",
        lineHeight: "1.1",
        marginBottom: "80px",
      }}
    >
      <span style={{ fontWeight: "600" }}>
        Senior Motion
      </span>
      <br />
      <span style={{ fontWeight: "300" }}>
        Graphic Designer
      </span>
    </h1>

    <div style={{ maxWidth: "720px", margin: "0 auto" }}>

      <p style={{ marginBottom: "15px", fontSize: "16px" }}>
        <strong>Position:</strong> Senior Motion Graphic Designer
      </p>

      <p style={{ marginBottom: "15px", fontSize: "16px" }}>
        <strong>Job ID:</strong> BNWJB20260127
      </p>

      <p style={{ marginBottom: "15px", fontSize: "16px" }}>
        <strong>Employment Type:</strong> Full Time (Remote)
      </p>

      <p style={{ marginBottom: "40px", fontSize: "16px" }}>
        <strong>Experience:</strong> 5 to 8 Years
      </p>

      <h4 style={{ marginBottom: "25px" }}>
        About the Role
      </h4>

      <p
        style={{
          fontSize: "16px",
          lineHeight: "1.8",
          color: "#777",
          marginBottom: "40px",
        }}
      >
        We are looking for a highly creative and detail-oriented Senior Motion Graphic Designer with 5–8 years of professional experience to join our dynamic creative team. The ideal candidate is passionate about visual storytelling, has a strong design sensibility, and possesses advanced expertise in Adobe Premiere Pro, Audition, After Effects, and Animate. You will play a key role in conceptualizing and executing compelling motion content across digital, social, web, and broadcast platforms.
      </p>

      <h4 style={{ marginBottom: "25px" }}>
        Key Responsibilities
      </h4>

      <ul
        style={{
          color: "#777",
          fontSize: "16px",
          lineHeight: "2",
          marginBottom: "40px",
        }}
      >
        <li>Conceptualize, design, and deliver high-quality motion graphics and video content aligned with brand guidelines and campaign objectives.</li>
        <li>Lead end-to-end video production including storyboarding, animation, editing, sound design, and final rendering.</li>
        <li>Create engaging explainer videos, social media creatives, brand films, product demos, event videos, and digital ads.</li>
        <li>Utilize Adobe After Effects for animation, compositing, motion design, and visual effects.</li>
        <li>Edit and refine video content using Adobe Premiere Pro, ensuring seamless storytelling and pacing.</li>
        <li>Enhance audio quality, mix soundtracks, and perform noise reduction using Adobe Audition.</li>
        <li>Develop interactive animations and vector-based motion content using Adobe Animate.</li>
        <li>Collaborate closely with creative directors, graphic designers, copywriters, and marketing teams.</li>
        <li>Maintain consistency in typography, color, branding, and visual identity across all projects.</li>
        <li>Manage multiple projects simultaneously while meeting tight deadlines without compromising quality.</li>
        <li>Stay updated with the latest motion design trends, animation techniques, and emerging technologies.</li>
      </ul>

      <h4 style={{ marginBottom: "25px" }}>
        Required Skills & Qualifications
      </h4>

      <ul
        style={{
          color: "#777",
          fontSize: "16px",
          lineHeight: "2",
          marginBottom: "40px",
        }}
      >
        <li>5–8 years of proven experience in motion graphics, video editing, and animation.</li>
        <li>Advanced proficiency in Adobe Creative Cloud tools, specifically Premiere Pro, Audition, After Effects, and Animate.</li>
        <li>Strong understanding of motion design principles, typography, composition, color theory, and timing.</li>
        <li>Experience with 2D animation, kinetic typography, logo animation, and visual storytelling.</li>
        <li>Solid knowledge of audio editing, sound design, and video formats/codecs.</li>
        <li>Ability to create storyboards and translate scripts into visual narratives.</li>
        <li>Strong attention to detail and a keen eye for aesthetics.</li>
        <li>Excellent time management and organizational skills.</li>
        <li>Strong communication and presentation skills.</li>
        <li>Ability to mentor junior designers and provide creative direction when required.</li>
      </ul>

      <h4 style={{ marginBottom: "25px" }}>
        Preferred Qualifications
      </h4>

      <ul
        style={{
          color: "#777",
          fontSize: "16px",
          lineHeight: "2",
          marginBottom: "40px",
        }}
      >
        <li>Experience working in an agency or fast-paced marketing environment.</li>
        <li>Basic understanding of 3D animation tools (Cinema 4D or Blender) is a plus.</li>
        <li>Knowledge of social media video formats and performance-driven content creation.</li>
      </ul>

<hr
  style={{
    border: "none",
    borderTop: "1px solid #ddd",
    marginTop: "60px",
    marginBottom: "30px",
  }}
/>

<div
  style={{
    display: "flex",
    alignItems: "center",
    gap: "20px",
    marginBottom: "50px",
  }}
>
  <Link
    to="/apply-job"
    style={{
      textDecoration: "none",
      color: "#111",
      fontSize: "16px",
      fontWeight: "500",
    }}
  >
    Apply
  </Link>

  <Link
    to="/apply-job"
    style={{
      width: "48px",
      height: "48px",
      borderRadius: "50%",
      background: "#e5e5e5",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      textDecoration: "none",
      color: "#111",
      fontSize: "22px",
    }}
  >
    →
  </Link>
</div>

    </div>
  </section>

  <Footer />
</>


);
}

export default CareerDetails5;